import { cx } from '@emotion/css';
import { Modal, ModalProps, Radio, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';

interface HangupChangeProps extends ModalProps {
  hangupStatusList?: string[];
  hangupStatus?: string;
  onHangupStatusChange?: (status: string) => void;
  onConfirm: (value: string) => void;
}

export const HangupChange = (props: HangupChangeProps) => {
  const {
    visible,
    hangupStatusList,
    hangupStatus,
    onHangupStatusChange,
    onConfirm,
    ...modalProps
  } = props;
  const { t } = useTranslate();
  const [selected, setSelected] = useState<string | undefined>(hangupStatus);

  const okButtonProps: ModalProps['okButtonProps'] = useMemo(
    () => ({
      disabled: !selected,
      onClick: () => selected && onConfirm(selected),
    }),
    [selected, onConfirm],
  );

  return (
    <Modal
      {...modalProps}
      bodyStyle={{ maxHeight: 400, overflowY: 'auto' }}
      visible={visible}
      title={t('hangup_select_others_modal_title')}
      okButtonProps={okButtonProps}
    >
      <Radio.Group
        className="!flex !flex-col"
        value={selected}
        onChange={(e) => {
          setSelected(e.target.value as string);
        }}
      >
        {hangupStatusList?.map((status) => (
          <Radio
            key={status}
            value={status}
            className={cx(
              '!py-2 !px-3 !mr-0 border border-solid rounded border-content-100 !mb-2',
              status === selected ? 'border-primary-focus' : undefined,
            )}
          >
            <Typography.Paragraph className="!mb-0 !max-w-[400px]" ellipsis={{ tooltip: true }}>
              {status}
            </Typography.Paragraph>
          </Radio>
        ))}
      </Radio.Group>
    </Modal>
  );
};
